import { EXPRESSIVE_ICON_VERSION_FOLDER } from './versions';
export const EXPRESSIVE_ICON_FILE_PATHS = {
  storybook: `./${EXPRESSIVE_ICON_VERSION_FOLDER}/`,
  local: `https://frontends-dev.udemycdn.com/design-system/icons-expressive/${EXPRESSIVE_ICON_VERSION_FOLDER}/`,
  dev: `https://frontends-dev.udemycdn.com/design-system/icons-expressive/${EXPRESSIVE_ICON_VERSION_FOLDER}/`,
  prod: `https://frontends.udemycdn.com/design-system/icons-expressive/${EXPRESSIVE_ICON_VERSION_FOLDER}/`
};
//# sourceMappingURL=asset-links.js.map